import {
  useWSSnackbar,
  WSControl,
  WSGrid,
  WSList,
  WSPage,
  WSText
} from "@wingspanhq/fe-component-library";
import { NotificationChannelSetPatch } from "@wingspanhq/wingspan-api-sdk";
import * as React from "react";
import { queriesNotifications } from "@query";
import { useSession } from "@hooks/useSession";
import { WSQueries } from "../../query/WSQuery";

export interface NotificationsTabProps {}

export const NotificationsTab: React.FC<NotificationsTabProps> = () => {
  const { personId } = useSession();
  const { openSnackbar } = useWSSnackbar();

  const channelSettingsQuery =
    queriesNotifications.getNotificationChannelSettings.useQuery(
      { personId },
      { enabled: !!personId }
    );

  const [updateChannelSettings] =
    queriesNotifications.updateNotificationChannelSettings.useMutation({
      onError: () => {
        openSnackbar({
          type: "warning",
          duration: 3000,
          message: "Sorry, something went wrong"
        });
      }
    });

  const updateDefaultChannels = (
    defaultChannels: NotificationChannelSetPatch
  ) =>
    updateChannelSettings({
      personId,
      notificationChannelSettingsPatch: { defaultChannels }
    });

  return (
    <WSPage title="Notifications">
      <WSGrid>
        <WSGrid.Item span={{ m: "10" }}>
          <WSQueries queries={{ channelSettingsQuery }}>
            {({ channelSettingsQuery: { data: channelSettings } }) => {
              const { defaultChannels } = channelSettings;

              return (
                <WSList gap="M">
                  <WSText.ParagraphSm color="gray500">
                    Choose how you'd like to receive notifications
                  </WSText.ParagraphSm>
                  <WSControl
                    type="switch"
                    value={defaultChannels.isInAppEnabled}
                    label="In-app"
                    helperText="Alerts and to-dos shown inside Wingspan"
                    onChange={value =>
                      updateDefaultChannels({ isInAppEnabled: value })
                    }
                  />
                  <WSControl
                    type="switch"
                    value={defaultChannels.isEmailEnabled}
                    label="Email"
                    helperText="Notifications sent to your email address"
                    onChange={value =>
                      updateDefaultChannels({ isEmailEnabled: value })
                    }
                  />
                  <WSControl
                    type="switch"
                    value={defaultChannels.isSmsEnabled}
                    label="SMS"
                    helperText="Text-message notifications sent to your phone"
                    onChange={value =>
                      updateDefaultChannels({ isSmsEnabled: value })
                    }
                  />
                </WSList>
              );
            }}
          </WSQueries>
        </WSGrid.Item>
      </WSGrid>
    </WSPage>
  );
};
